import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { Description } from 'components/Text'
import { VerificationIntroduction } from 'pages/Verification/_components/VerificationIntroduction'
import {
  DocumentActions,
  DocumentCategoryKey,
  RequiredDocuments,
  UploadedDocument,
} from '../helpers/types'
import { CategoryDocuments } from './CategoryDocuments'

export interface UploadDocumentsFormData {
  requiredCategories: DocumentCategoryKey[]
  requiredDocuments: RequiredDocuments
  uploadedDocuments: UploadedDocument[]
  documentActions: DocumentActions
}

export const UploadDocumentsForm = ({
  requiredCategories,
  requiredDocuments,
  uploadedDocuments,
  documentActions,
}: UploadDocumentsFormData) => {
  const { t } = useTranslation()

  return (
    <Box>
      <VerificationIntroduction
        hasPadding
        textList={[
          t('uploadDocuments.introduction.requirements'),
          t('uploadDocuments.introduction.tailoredToIndustry'),
          t('uploadDocuments.introduction.correctDocumentation'),
        ]}
      />
      {!!requiredCategories?.length ? (
        requiredCategories?.map((category: DocumentCategoryKey) => (
          <CategoryDocuments
            key={category}
            category={category}
            requiredDocuments={requiredDocuments?.[category]}
            uploadedDocuments={uploadedDocuments?.filter(
              ({ documentId }) => documentId?.category === category
            )}
            documentActions={documentActions}
          />
        ))
      ) : (
        <Description>{t('uploadDocuments.requiredDocumentsEmpty')}</Description>
      )}
    </Box>
  )
}
